import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Route, Redirect } from 'react-router-dom';

class AuthRouteMobile extends Component {
	render() {
		const { accessToken, accessIsForMobile, component: Component, ...rest } = this.props;
		return (
			<Route
				{...rest}
				render={function (props) {
					const { location } = props;
					if (accessToken) {
						return <Component {...props} />;
					} else {
						return (
							<Redirect
								to={{
									pathname: '/mobile/login',
									state: { from: location },
								}}
							/>
						);
					}
				}}
			/>
		);
	}
}

AuthRouteMobile.propTypes = {
	accessToken: PropTypes.string,
	accessIsForMobile: PropTypes.bool,
	component: PropTypes.object,
	location: PropTypes.object,
};

function mapStateToProps(state) {
	return { accessToken: state.auth.accessToken, accessIsForMobile: state.auth.accessIsForMobile };
}

export default connect(mapStateToProps)(AuthRouteMobile);
//export default AuthRoute;
